__turbopack_context__.v({
  "address": "styles-module__jYmOca__address",
  "backIcon": "styles-module__jYmOca__backIcon",
  "bar": "styles-module__jYmOca__bar",
  "chevronIcon": "styles-module__jYmOca__chevronIcon",
  "markerIcon": "styles-module__jYmOca__markerIcon",
});
